import React from "react";
import { SidebarWithPermission } from "./Sidebar/Sidebar";
import Toast from "./Common/Toast/Toast";

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        display: "grid",
        gridTemplateAreas: `  'left center'  `,
        gridTemplateColumns: "90px calc(100% - 90px)",
        gridTemplateRows: "100%",
      }}
    >
      <Toast />
      <div
        style={{
          gridArea: "left",
        }}
      >
        <SidebarWithPermission />
      </div>
      <div
        id="CONTENT"
        style={{
          gridArea: "center",
          overflow: "auto",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
